import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('DOCTORS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class DoctorsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'doctors' como el nombre del recurso a la clase base
    super('doctors');
    log.debug('Servicio de Doctores inicializado');
  }

}
